// AGRUPA_2810 (GROK2): junta páginas espalhadas em UMA entrada do menu com abas internas.
// Só menu + abas: rotas/páginas continuam iguais (rota antiga abre a aba certa).
// Switches: private/AGRUPA_FINANCEIRO_2810_OFF, AGRUPA_CLIENTES_2810_OFF, AGRUPA_CATALOGO_2810_OFF.
// Permissão: aba só aparece se a página já estava liberada para o usuário (navPaths = menu filtrado por permissão).
export const AGRUPA_GROUPS_2810 = [
  {
    key: 'financeiro', label: 'Financeiro',
    anchor: ['/financeiro', '/buy-credits', '/sales', '/logs-financeiros', '/gestor-xui/credit-logs', '/gestor-xui/reseller-billing', '/gestor-xui/my-reseller-billing', '/bonification'],
    quick: [['/buy-credits', 'Comprar créditos']],
    tabs: [
      ['Carteira', [['/financeiro', 'Resumo'], ['/buy-credits', 'Comprar créditos'], ['/postpaid-wallet', 'Pós-pago', 'alias']]],
      ['Movimentações', [['/logs-financeiros', 'Movimentações'], ['/gestor-xui/credit-logs', 'Extrato de créditos']]],
      ['Vendas', [['/sales', 'Vendas']]],
      ['Cobrança de revendas', [['/gestor-xui/reseller-billing', 'Modo crédito'], ['/gestor-xui/my-reseller-billing', 'Modo crédito da rede']]],
      ['Bônus', [['/bonification', 'Bônus']]],
    ],
  },
  {
    key: 'clientes', label: 'Clientes',
    // Testes continua também no menu (acesso rápido); por isso não entra no anchor.
    anchor: ['/gestor-xui/clients', '/gestor-xui/live-clients', '/gestor-xui/inactive-clients', '/gestor-xui/my-portfolio', '/app-activations'],
    tabs: [
      ['Ativos', [['/gestor-xui/clients', 'Todos'], ['/gestor-xui/my-portfolio', 'Minha carteira']]],
      ['Testes', [['/gestor-xui/tests', 'Testes']]],
      ['Ao vivo', [['/gestor-xui/live-clients', 'Ao vivo']]],
      ['Inativos', [['/gestor-xui/inactive-clients', 'Inativos']]],
      ['Apps/Licenças', [['/app-activations', 'Ativar aplicativos']]],
    ],
  },
  {
    key: 'catalogo', label: 'Catálogo e Planos',
    // /pricing (preço do SaaS) fica fora, só admin.
    anchor: ['/gestor-xui/partner-apps', '/gestor-xui/categories', '/gestor-xui/catalog', '/gestor-xui/credit-packs', '/gestor-xui/plan-pricing'],
    tabs: [
      ['Planos', [['/gestor-xui/categories', 'Planos'], ['/gestor-xui/plan-pricing', 'Preços dos planos']]],
      ['Conteúdos', [['/gestor-xui/catalog', 'Conteúdos']]],
      ['Pacotes de crédito', [['/gestor-xui/credit-packs', 'Pacotes de crédito']]],
      ['Apps parceiros', [['/gestor-xui/partner-apps', 'Apps parceiros']]],
    ],
  },
  // AGRUPA_5_2810 (GROK2): os 5 grupos que faltavam. Aba só aparece se a página já era liberada (navPaths).
  {
    key: 'ajustes', label: 'Ajustes',
    anchor: ['/settings', '/gestor-xui/gateway', '/api-integrations', '/integrations', '/reseller-dns', '/gestor-xui/servers', '/gestor-xui/server-recovery', '/gestor-xui/credential-generation'],
    tabs: [
      ['Perfil e marca', [['/settings', 'Ajustes']]],
      ['Integrações', [['/gestor-xui/gateway', 'Bancos'], ['/api-integrations', 'API e automações'], ['/integrations', 'Integrações']]],
      ['Servidores', [['/gestor-xui/servers', 'Servidores'], ['/gestor-xui/server-recovery', 'Recuperação'], ['/gestor-xui/credential-generation', 'Credenciais']]],
      ['Domínio/DNS', [['/reseller-dns', 'DNS']]],
    ],
  },
  {
    key: 'revendas', label: 'Revendas',
    anchor: ['/gestor-xui/resellers', '/gestor-xui/inactive-resellers', '/gestor-xui/reseller-migration'],
    tabs: [
      ['Revendas', [['/gestor-xui/resellers', 'Revendas']]],
      ['Inativas', [['/gestor-xui/inactive-resellers', 'Inativas']]],
      ['Migração', [['/gestor-xui/reseller-migration', 'Migração']]],
    ],
  },
  {
    key: 'equipe', flag: 'revendas', label: 'Equipe',
    anchor: ['/team', '/team/monitor', '/attendant/metrics', '/permissions'],
    tabs: [
      ['Atendentes', [['/team', 'Atendentes']]],
      ['Monitor', [['/team/monitor', 'Monitor'], ['/attendant/metrics', 'Métricas']]],
      ['Permissões dos perfis', [['/permissions', 'Permissões dos perfis']]],
    ],
  },
  {
    key: 'comunicacao', label: 'Notificações',
    anchor: ['/notification-templates', '/gestor-xui/checkout-notifications', '/mass-dispatch', '/comunicados'],
    tabs: [
      ['Modelos', [['/notification-templates', 'Modelos'], ['/gestor-xui/checkout-notifications', 'Avisos PIX']]],
      ['Disparo em massa', [['/mass-dispatch', 'Disparo em massa']]],
      ['Comunicados', [['/comunicados', 'Comunicados']]],
    ],
  },
  {
    key: 'materiais', label: 'Materiais',
    anchor: ['/materiais', '/admin/materiais', '/reseller-manual', '/admin/reseller-manual', '/community-support'],
    tabs: [
      ['Materiais', [['/materiais', 'Ver'], ['/admin/materiais', 'Editar']]],
      ['Manual', [['/reseller-manual', 'Ver'], ['/admin/reseller-manual', 'Editar']]],
      ['Comunidade', [['/community-support', 'Comunidade']]],
    ],
  },
  {
    key: 'registros', label: 'Registros',
    anchor: ['/logs-globais', '/xui-metrics', '/ranking'],
    tabs: [
      ['Logs globais', [['/logs-globais', 'Logs globais']]],
      ['Métricas XUI', [['/xui-metrics', 'Métricas XUI']]],
      ['Ranking', [['/ranking', 'Ranking']]],
    ],
  },
];
export const AGRUPA_ADMIN_EXTRA_2810 = new Set(['/gestor-xui/plan-pricing',
  // AGRUPA_5_2810: rotas sem item de menu que o admin já abria
  '/gestor-xui/server-recovery', '/team/monitor', '/attendant/metrics', '/admin/reseller-manual', '/xui-metrics', '/mass-dispatch', '/gestor-xui/checkout-notifications']); // rota sem item de menu; admin já abria

const norm = (p) => String(p || '').split('?')[0].replace(/\/+$/, '');
// FIN_REVENDA_2910: revenda vê Financeiro enxuto (Resumo/Vendas/Bônus) e Movimentações vai p/ Registros. Admin inalterado.
const FIN_REV_FIN_2910 = { key: 'financeiro', label: 'Financeiro', anchor: ['/financeiro', '/sales', '/bonification', '/buy-credits', '/gestor-xui/reseller-billing', '/gestor-xui/my-reseller-billing'], quick: [],
  tabs: [['Resumo', [['/financeiro', 'Resumo']]], ['Vendas', [['/sales', 'Vendas']]], ['Bônus', [['/bonification', 'Bônus']]]] };
const FIN_REV_MOV_2910 = ['Movimentações', [['/logs-financeiros', 'Movimentações'], ['/gestor-xui/credit-logs', 'Extrato de créditos']]];
export function agrupaActive2810(flags) {
  const fr = !!(flags && flags.fin_revenda);
  return AGRUPA_GROUPS_2810.filter((g) => flags && (flags[g.flag || g.key] || (fr && g.key === 'registros'))).map((g) => {
    if (flags.conteudos_3010 && g.key === 'catalogo') g = { ...g, anchor: g.anchor.filter((p) => p !== '/gestor-xui/catalog'), tabs: g.tabs.filter(([l]) => l !== 'Conteúdos') }; // CONTEUDOS_3010: Conteúdos sai do Catálogo e Planos e vira aba própria
    if (!fr) return g;
    if (g.key === 'financeiro') return FIN_REV_FIN_2910;
    if (g.key === 'registros') return { ...g, anchor: [...g.anchor, '/logs-financeiros', '/gestor-xui/credit-logs'], tabs: [FIN_REV_MOV_2910, ...g.tabs] };
    return g;
  });
}
export function agrupaCan2810(path, { navPaths, isAdmin }) {
  return !!navPaths && (navPaths.has(path) || (isAdmin && AGRUPA_ADMIN_EXTRA_2810.has(path)));
}
// Abas visíveis do grupo onde está a rota atual (null = não é página de grupo / só 1 aba).
export function agrupaTabs2810(pathname, flags, ctx) {
  const p = norm(pathname);
  for (const g of agrupaActive2810(flags)) {
    const all = g.tabs.flatMap(([, subs]) => subs.map(([to]) => to));
    if (!all.includes(p)) continue;
    const tabs = g.tabs.map(([label, subs]) => {
      // CREDITOS_HEADER_2810: Comprar créditos sai do Financeiro (fica no saldo do topo direito)
      const vis = subs.filter(([to, , alias]) => !alias && agrupaCan2810(to, ctx) && !(flags && flags.creditos_header && to === '/buy-credits' && p !== to));
      const active = subs.some(([to]) => to === p);
      if (!vis.length) return null; // sem permissão = aba não existe
      return { label, to: (vis[0] || subs[0])[0], active, subs: vis.length > 1 ? vis.map(([to, l]) => ({ to, label: l, active: to === p })) : [] };
    }).filter(Boolean);
    const quick = (g.quick || []).filter(([to]) => to !== p && agrupaCan2810(to, ctx) && !(flags && flags.creditos_header && to === '/buy-credits')).map(([to, label]) => ({ to, label }));
    return { key: g.key, tabs: tabs.length > 1 ? tabs : [], quick, sub: (tabs.find((t) => t.active) || {}).subs || [] };
  }
  return null;
}
// Menu: troca as várias entradas do grupo por UMA (no lugar da primeira), apontando p/ 1ª página permitida.
export function agrupaMenu2810(out, srcGroups, flags) {
  const groups = agrupaActive2810(flags);
  if (!groups.length) return out;
  const srcPaths = new Set((srcGroups || []).flatMap((g) => (g.items || []).map((i) => norm(i.path))));
  let res = out;
  for (const g of groups) {
    const members = new Set(g.anchor);
    const best = g.anchor.find((p) => srcPaths.has(p));
    if (!best) continue;
    let placed = false;
    res = res.map((grp) => {
      const items = [];
      for (const it of grp.items || []) {
        if (!members.has(norm(it.path))) { items.push(it); continue; }
        if (!placed) { placed = true; items.push({ ...it, path: best, label: g.label, agrupa2810: g.key }); }
      }
      return items.length ? { ...grp, items, defaultPath: items[0].path } : null;
    }).filter(Boolean);
  }
  return res;
}
